module.exports = __webpack_public_path__ + "static/media/requisites-icon.509d68db.svg";